/* eslint-disable array-callback-return */
import { useMemo, useRef, useState } from "react";

//assets
import { SvgCross } from "assets/icons/js/SvgCross";
import SvgBed from "assets/icons/js/SvgBed";
import { SvgRoomAndBeds } from "assets/icons/js/SvgRoomAndBeds";

import { ReactComponent as MarriottbonvoyIcon } from "assets/marriottbonvoy.svg";
//components
import Carousel from "components/Carousel";
import Modal from "components/LoginAndRegister/Modal";
import Gallery from "../GalleryCarouselPopup";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useOnClickOutside } from "customHooks/useOnClickOutside";

//scss
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

const ListingRoomsAndBeds = ({ newRoomData }) => {
	const popupRef = useRef(null);
	useOnClickOutside(popupRef, () => setOpen(false));

	const [open, setOpen] = useState(false);

	const width = useMediaQuery();

	const isMobile = width < 668 ? true : false;

	const roomData = newRoomData?.data?.data?.data;
	const [amenities, setAmenities] = useState([]);
	const [active, setActive] = useState("");
	const [openGallery, setOpenGallery] = useState(false);
	const [images, setImages] = useState([]);

	const theme = useTheme();

	useMemo(
		() =>
			roomData?.length > 0 &&
			// eslint-disable-next-line array-callback-return
			roomData?.map((room) => {
				if (active === room?.room_name) {
					setAmenities([]);
					setAmenities((prev) => [
						...prev,
						{
							list: room?.bedroom_amenities?.split(","),
							category: "Bedroom",
						},
					]);
					setAmenities((prev) => [
						...prev,
						{ list: room?.bath_amenities?.split(","), category: "Bathroom" },
					]);
					setAmenities((prev) => [
						...prev,
						{ list: room?.storage?.split(","), category: "Storage" },
					]);
				} else {
					return null;
				}
			}),
		[roomData, active],
	);
	// console.log("room image", JSON.parse(roomData[0]?.photos)[0]?.file);
	const roomsList = useMemo(
		() =>
			roomData?.length > 0 &&
			roomData?.map((room, index) => (
				// <div className="room__con" key={index}>
				// 	<div className="content-top">
				// 		{room?.photos && JSON.parse(room?.photos)[0]?.imageId ? (
				// 			<span className="top-left">
				// 				<img
				// 					style={{ objectFit: "cover" }}
				// 					src={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/f_auto,fl_force_strip.progressive:steep,q_40,w_580,h_270,c_fill/c_scale,g_center,l_SAFFRONSTAYS_WATERMARK_pqmxfs,h_0.22,o_50,fl_relative,x_0,y_0/v1656753365/${
				// 						JSON.parse(room?.photos)[0].imageId
				// 					}.webp`}
				// 					alt="#"
				// 					onClick={() => {
				// 						setOpenGallery(true);
				// 						setImages(JSON.parse(room.photos));
				// 					}}
				// 				/>
				// 				<SvgRoomAndBeds />
				// 			</span>
				// 		) : (
				// 			<div className="icon__con">
				// 				<SvgBed />
				// 			</div>
				// 		)}
				// 	</div>
				// 	<div className="content-list">
				// 		<div className="top-right">
				// 			<h3>{room?.room_name}</h3>
				// 			<div>
				// 				{room?.floor_room ? (
				// 					<span>
				// 						{room?.floor_room}
				// 						<span className="line"></span>
				// 					</span>
				// 				) : null}
				// 				{room.dimension_len ? (
				// 					<span className="room-type-2">
				// 						{room.dimension_len} ft x {room.dimension_wid} ft
				// 						<span className="line"></span>
				// 					</span>
				// 				) : null}
				// 				{/* {room.min_no_guests ? (
				// 					<span className="room-type-3">
				// 						{room.min_no_guests} minimum guests
				// 						<span className="line"></span>
				// 					</span>
				// 				) : null} */}
				// 				{room?.extra_guest ? (
				// 					<span className="line">
				// 						{room?.extra_guest} extra guests
				// 						<span className="line"></span>
				// 					</span>
				// 				) : null}
				// 				{room?.sleep_arrangement ? (
				// 					<span>{room?.sleep_arrangement}</span>
				// 				) : null}
				// 			</div>
				// 		</div>
				// 		{/* <div className="content-left">
				// 			{room.sleep_arrangement && <span>{room.sleep_arrangement}</span>}
				// 			{room.view_from_room && <span>{room.view_from_room}</span>}
				// 			{room.bathroom_type && <span>{room.bathroom_type}</span>}
				// 		</div> */}
				// 		{room?.bedroom_amenities?.split(",").length > 0 ||
				// 		room?.bath_amenities?.split(",").length > 0 ||
				// 		room?.storage?.split(",").length > 0 ? (
				// 			<div
				// 				className="content-right"
				// 				onClick={() => {
				// 					if (
				// 						room?.bedroom_amenities?.split(",").length > 0 ||
				// 						room?.bath_amenities?.split(",").length > 0 ||
				// 						room?.storage?.split(",").length > 0
				// 					) {
				// 						setActive(room.room_name);
				// 						setOpen(true);
				// 					}
				// 				}}
				// 			>
				// 				View Details
				// 			</div>
				// 		) : null}
				// 	</div>
				// </div>
				<div
					style={{
						height:
							room?.photos &&
							room?.photos.length !== 0 &&
							JSON.parse(room?.photos)?.length !== 0
								? "445px"
								: "373px",
						background: theme.background2,
						border: theme.borderBookingBox,
					}}
					className="listing-room-card-wrapper"
				>
					<div className="listing-room-card-content">
						{room?.photos &&
						room?.photos.length !== 0 &&
						JSON.parse(room?.photos)?.length !== 0 ? (
							<div className="listing-room-card-top">
								<img
									src={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-100,w-295,h-193,f-webp/${
										JSON.parse(room?.photos)[0]?.imageId
									}`}
									alt=""
								/>
								<p>{room?.room_name}</p>
								<p>{room?.sleep_arrangement}</p>
							</div>
						) : (
							<div
								className="listing-room-card-top-noimg"
								style={{ background: theme?.progressBar.background }}
							>
								<p>{room?.room_name}</p>
								<p>{room?.sleep_arrangement}</p>
							</div>
						)}

						<div className="listing-room-card-bottom">
							<ul>
								<li style={{ color: theme.baseTextColor }}>
									This room is on the {room?.floor_room} and can
									accomodate&nbsp;
									{room?.min_no_guests} guests{" "}
									{room?.extra_guest === 0
										? ""
										: `+ ${room?.extra_guest} extra
									guest(s)`}
								</li>
								<li style={{ color: theme.baseTextColor }}>
									It is equipped with{" "}
									{room?.bedroom_amenities?.replaceAll(",", ", ")}
								</li>
								<li style={{ color: theme.baseTextColor }}>
									It has an {room?.bathroom_type} bathroom. The bathroom has a{" "}
									{room?.bath_amenities?.replaceAll(",", ", ")}
								</li>
							</ul>
						</div>
					</div>
				</div>
			)),
		[roomData],
	);
	return (
		<section className="listing__rooms-beds">
			{/* {openGallery && (
				<Gallery open={openGallery} setOpen={setOpenGallery} images={images} />
			)} */}
			<Carousel theme={theme} scrollValue={isMobile ? 328 : 535}>
				{roomsList}
			</Carousel>
			{/* <Modal shouldShow={open} onClose={() => setOpen(false)}>
				<div className="all-amenities" ref={popupRef}>
					<h3>
						{active} Amenities
						<SvgCross
							id="all-amenities__cross"
							onClick={() => setOpen(false)}
						/>
					</h3>
					<div className="all-amenities__body">
						{amenities.map((item, index) => {
							if (item?.title === "Marriott Bonvoy Home") {
								return <MarriottbonvoyIcon id="marriot-icon" />;
							}
							return (
								<div className="all-amenities__category" key={index}>
									{item?.list?.length ? (
										<div className="sub-heading">{item.category}</div>
									) : null}
									{item?.list?.length &&
										item.list.map((item, idx) => {
											return (
												<>
													{item ? <li className="text-style">{item}</li> : null}
												</>
											);
										})}
								</div>
							);
						})}
					</div>
				</div>
			</Modal> */}
		</section>
	);
};

export default ListingRoomsAndBeds;
